import React from 'react';

const TitleCard = ({ title }) => {
    return (
        <div className="w-full py-1">
            <h2 className="text-xl font-semibold capitalize w-full text-center text-gray-800 p-4 rounded-md shadow-sm">
                {title}
            </h2>
        </div>
    );
};

export default TitleCard;
